import React from 'react';
import { useNavigate } from "react-router-dom";
import { withStyles } from '@material-ui/core/styles';
import {Grid, Box, Button} from '@material-ui/core';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import axios from 'axios';
import {API_URL} from '../utils/EnvVars';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

var vertical='top',horizontal='center';

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => {
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false); 
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [showAlert, setShowAlert] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");

  const [address, setAddress] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [notes, setNotes] = React.useState("");

  
  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };

  function hideAlert(){
		setShowAlert(false);
	}


  React.useEffect(() => {	
    if(props.dataObj!=null && props.dataObj.autoId){	
      setAddress(props.dataObj.address);
      setPhone(props.dataObj.phone);
      setNotes(props.dataObj.notes);

    }else{
      setAddress("");
      setPhone("");
      setNotes("");
    
    }
	}, [props.dataObj,open]);

	function saveData(){
    if(!address){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Select Company Name & Address");			
      return false;
    }
    if(!phone){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter phone, email & website");			
      return false;
    }
    if(!notes){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter notes");			
      return false;
    }
    
		if(address && address.length>1){ 
			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/form-data',
					'device': 'web',
					'registerId': props.userObj.registerId,
					'uid': props.userObj.loginId,
					'fullName': props.userObj.fullName,
					'token': props.userObj.token,
				}
			}; 
			const data = new FormData();
      data.append('address', address);      
      data.append('phone', phone);
      data.append('notes', notes);
      data.append('currentFile', props.dataObj.invoiceLogo);
      
      var browseFile = document.querySelector('#selectedFile');
      if(browseFile && browseFile.files[0] && browseFile.files[0].name.length>0){
        data.append("uploadedFiles", browseFile.files[0]);
      }

			axios.post(API_URL+'/crm-create-invoices-setting', data, axiosHeader)
			.then((response) => {
				///console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){
          props.updatedList(response.data.list);
          setSeverityAlert("success");
          setOpen(false);
					setShowAlert(true);
					setAlertMessage("Invoice setting has been saved.");          	
					return false;

        }else if(response.data.responseTxt==="invalidtoken"){
          navigate('/invalidtoken');
  
				}else{
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("This invoice setting could not be saved.");			
					return false;
				}
			})
			.catch((error) => {
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage(""+error);			
					return false;
			})	
		}		
	}
  

  return (
    <>
      <Dialog fullWidth maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}></DialogTitle>
          <DialogContent style={{height:'88vh'}}>
            <Grid item   md={12} xs={12} className="test-instructions" >
                  <div className="btmbdrgry"><h3>{props.dataObj!=null?<>Edit</>:<>New</>} Invoice Setting</h3></div>
                  <p>
                      <table style={{backgroundColor:'#000000',width:'100%' }} cellSpacing="1" cellPadding="3" >
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td style={{verticalAlign: 'top'}} >
                              Company Name<br/>
                              Address
                            </td>
                            <td style={{verticalAlign: 'top'}} >
                              <TextField onChange={event => setAddress(event.target.value)} value={address} placeholder={'Enter Company Name & Address'} fullWidth variant="standard" multiline rows={4} />
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td style={{verticalAlign: 'top'}} >
                              Phone<br/>
                              Email<br/>
                              Website<br/>
                            </td>
                            <td style={{verticalAlign: 'top'}} >
                              <TextField onChange={event => setPhone(event.target.value)} value={phone} placeholder={'Enter Phone, Email & Website'} fullWidth variant="standard" multiline rows={4} />
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td style={{verticalAlign: 'top'}} >Notes</td>
                            <td style={{verticalAlign: 'top'}} >
                            <TextField onChange={event => setNotes(event.target.value)} value={notes} placeholder={'Enter Notes'} fullWidth variant="standard" multiline rows={5} />
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Company Logo Image</td>
                            <td>
                            <input type="file" id="selectedFile" />
                            </td>                            
                        </tr>  

                      </table>

                      <Box mt={2}>
                          <Button onClick={() => {handleClose()}} style={{marginRight:12}} size="small" variant="outlined" >Cancel</Button>
					    	          <Button onClick={() => {saveData()}} size="small" variant="contained" style={{marginRight:12, backgroundColor:'#008000',color:'#FFF',marginRight:10}} >Save</Button>
								      </Box>

                  </p>
            </Grid>
          </DialogContent>
      </Dialog>
      
        <Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>

    </>
  );

});

export default CustomizedDialogs;